import { formatDate } from "@/lib/api";
import { EntityManager } from "./EntityManager";

const fields = [
  { name: "text", label: "Texte du flash", required: true, full: true },
  { name: "link", label: "Lien (facultatif, ex. /rubrique/politique ou https://…)", full: true },
  { name: "active", label: "Actif (affiché dans le bandeau)", type: "switch" },
];
const columns = [
  { key: "text", label: "Flash", render: (t) => <span className="font-semibold">{t.text}</span> },
  { key: "link", label: "Lien", render: (t) => <span className="text-xs text-zinc-500">{t.link || "—"}</span> },
  { key: "active", label: "Statut", render: (t) => <span className={`text-xs font-bold ${t.active ? "text-green-600" : "text-zinc-400"}`}>{t.active ? "Actif" : "Inactif"}</span> },
  { key: "created_at", label: "Ajouté", render: (t) => formatDate(t.created_at) },
];

const DEFAULTS = { text: "", link: "", active: true };

export default function TickerManager() {
  return <EntityManager title="Flash infos" description="Actualités en bande passante défilante en haut du site. Les articles marqués « Flash » s'y ajoutent automatiquement." listUrl="/admin/ticker" baseUrl="/ticker" fields={fields} columns={columns} testId="ticker" defaults={DEFAULTS} />;
}
